import React from "react";
import { Navigate, useParams } from "react-router-dom";

/**
 * The group detail is now a slide-over panel on the list, not a pushed route
 * (design §5.2). This legacy route is kept as a deep link (§9): it redirects to
 * the Client Groups tab with the group pre-selected, which opens its panel.
 */
export default function ClientGroupDetailPage() {
  const { groupId } = useParams();
  return (
    <Navigate
      to={`/admin/marketing?tab=groups&group=${groupId ?? ""}`}
      replace
    />
  );
}
